// src/Header.js
import React from 'react';
import { Link } from 'react-router-dom'; 
import './Header.css';

function Header({ theme = 'light', onToggleTheme }) {
  return (
    <header className="app-header">
      <div className="site-name">
        <Link to="/">のりまきの備忘録</Link>
      </div>
      <div className="header-actions">
        <button
          type="button"
          className={`theme-toggle ${theme === 'dark' ? 'theme-toggle-dark' : 'theme-toggle-light'}`}
          onClick={onToggleTheme}
          aria-label="テーマ切り替え"
        >
          <span className="theme-toggle-track">
            <span className="theme-toggle-thumb" />
          </span>
          <span className="theme-toggle-text">
            {theme === 'dark' ? 'Dark' : 'Light'}
          </span>
        </button>
      </div>
    </header>
  );
}


export default Header;
